import React from 'react';
import { Box, TextField, IconButton } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ro } from 'date-fns/locale';
import ClearIcon from '@mui/icons-material/Clear';

const DateRangeFilterComponent = ({ item, applyValue }) => {
  const currentValue = item.value || [null, null];
  const startDate = currentValue[0] && !isNaN(new Date(currentValue[0]).getTime()) ? new Date(currentValue[0]) : null;
  const endDate = currentValue[1] && !isNaN(new Date(currentValue[1]).getTime()) ? new Date(currentValue[1]) : null;

  const handleStartChange = (newValue) => {
    applyValue({ ...item, value: [newValue, currentValue[1]] });
  };

  const handleEndChange = (newValue) => {
    applyValue({ ...item, value: [currentValue[0], newValue] });
  };

  const handleClear = () => {
    applyValue({ ...item, value: [null, null] });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ro}>
      <Box display="flex" flexDirection="column" gap={1}>
        <DatePicker
          label="De la"
          value={startDate}
          onChange={handleStartChange}
          renderInput={(params) => <TextField {...params} size="small" fullWidth />}
          inputFormat="dd.MM.yyyy"
          className='inputMicMic2'
        />
        <Box display="flex" alignItems="center" gap={0.5}>
          <DatePicker
            label="Până la"
            value={endDate}
            onChange={handleEndChange}
            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
            inputFormat="dd.MM.yyyy"
            className='inputMicMic2'
          />
          <IconButton size="small" onClick={handleClear}>
            <ClearIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangeFilterComponent;
